import(/* webpackMode: "eager" */ "/opt/build/repo/app/_components/layout/Header/CryptopediaHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Grid"] */ "/opt/build/repo/components/layout/Grid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentContainer"] */ "/opt/build/repo/components/layout/Layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/site/Footer/Copyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
